import React from 'react';
import Layout from '../common/AdminLayout';
import ConsentForms from '../../../containers/consent';

const Consent = () => {
  return (<ConsentForms />)
};

export default Consent;
